import React from 'react';
import PropTypes from 'prop-types';
import { createFragmentContainer, graphql } from 'react-relay';

// helpers
import get from 'lodash.get';

// styles
import styles from './SbSharedTitle.scss';

// constants
import { pageTypeConstants as pageTypes } from '../../constants/pageTypeConstants';
const { SEARCH } = pageTypes;

const SbSharedTitleComponent = ({ searchBrowse, searchTerm }) => {
    const header = get(searchBrowse, 'meta.header');
    const pageType = get(searchBrowse, 'pageType');
    const shownSearchTerm = get(searchBrowse, 'spellCheck.newQuery') || searchTerm;

    return (
        <h1 className={styles.header} data-tn="header-title">
            {pageType === SEARCH ? (
                <span>
                    {header}{' '}
                    <i className={styles.searchTerm} data-tn="search-term">
                        "{shownSearchTerm}"
                    </i>
                </span>
            ) : (
                header
            )}
        </h1>
    );
};

SbSharedTitleComponent.propTypes = {
    searchBrowse: PropTypes.object.isRequired,
    searchTerm: PropTypes.string,
};

export const SbSharedTitle = createFragmentContainer(SbSharedTitleComponent, {
    searchBrowse: graphql`
        fragment SbSharedTitle_searchBrowse on SearchBrowseQueryConnection {
            pageType
            spellCheck {
                newQuery
            }
            meta {
                header
            }
        }
    `,
});
